export default __webpack_public_path__ + "static/media/Helm of the Invincible.d7e3832c.jpg";